export default __webpack_public_path__ + "media/images/linkedin-9b4bdf3cb9366539d8e70e874a8608ab.svg";